export default __webpack_public_path__ + "static/media/qb-logo-horizontal-preferred.cc246289.svg";